import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {WorkplaceModel, WorkplaceShutdownModel} from '@/libs/Api';
import {WorkplacesDataService} from '@/libs/workplaces/workplaces-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';
import { WorkplaceShutdownsDataService } from '../workplace-shutdowns-data-service';

export const workplacesStore = registerCrudStore<WorkplaceModel, WorkplaceModel>(BusinessModule.Workplace, new WorkplacesDataService());
export const workplaceShutdownsStore = registerCrudStore<WorkplaceShutdownModel, WorkplaceShutdownModel>(BusinessModule.WorkplaceShutdown, new WorkplaceShutdownsDataService());
